import axios from "axios";
import {BASE_URL} from "./url_config.js";
import {log} from "@/composables/useLog"
// import store from "@/store";
// import { useStore } from 'vuex'

export const  getClientsGeneralSettings= async ()=>{
    log("welcome in getClientsGeneralSettings")
    // const store = useStore()
    log(1.1)
    try{
        log(1.2)
        const headers= {

            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        const url=BASE_URL+'/home/getClientsGeneralSettingsApi'
        log(url)
        // log(headers)
        log(1.3)
        const result= await axios.get(url,  {headers: headers})
        log(1.4)
        log("result.data din axios in getClientsGeneralSettings")
        // log(result)
        log(result.data)
        log(1.5)
        if(result.data.error==true){
            alert("eroare in getClientsGeneralSettings de la getClientsGeneralSettingsApi")
            log("am gasit la intoarcere axios in getGeneralClientSettings errror==true!, iesim")
            return result.data
        }
        else{
            return result.data

        }
    }catch{
        log("1.1.1")
        log("alerta de eroare la getClientsGeneralSettings")
        return {error:true,message:"invalid data"}
    }
}
export const  getServicesGeneralSettings= async ()=>{
    log("welcome in getGeneralServiceSettings")
    // const store = useStore()
    log(1.1)
    try{
        log(1.2)
        const headers= {

            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        const url=BASE_URL+'/home/getServicesGeneralSettingsApi'
        log(url)
        log(headers)
        log(1.3)
        const result= await axios.get(url,  {headers: headers})
        log(1.4)
        log("result.data din axios in getServicesGeneralSettings")
        // log(result)
        log(result.data)
        log(1.5)
        if(result.data.error==true){
            alert("eroare in getGeneralServiceSettings de la getGeneralServiceSettingsApi")
            log("am gasit la intoarcere axios in getGeneralServiceSettings errror==true!, iesim")
            return result.data
        }
        else{
            return result.data

        }
    }catch{
        log("1.1.1")
        log("alerta de eroare la autentificare get getGeneralServiceSettings")
        return {error:true,message:"invalid data"}
    }
}

const useGetGeneralSettings = () => {
    return { getClientsGeneralSettings, getServicesGeneralSettings  }
}
export default useGetGeneralSettings

